<nb-card>
  <nb-card-header>
    <div class="menu-buttons"></div>

    <button
      class="cancel"
      nbButton
      outline
      status="info"
      size="small"
      (click)="cancel()"
    >
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>

  <nb-card-body>
    <div id="print-section" class="print-layout">
      <table width="100%" cellpadding="0" cellspacing="0" class="table-header">
        <tr>
          <td style="text-align: center">
            <h4>{{ shop.title }}</h4>
          </td>
        </tr>
        <tr>
          <td style="text-align: center">
            <label>
              {{ shop.address }}
            </label>
          </td>
        </tr>
        <tr>
          <td style="text-align: center">
            <label>
              ĐT: {{ shop.mobile }}
              <span *ngIf="shop.email"> - Email: {{ shop.email }} </span>
              <span *ngIf="shop.website"> - Web: {{ shop.website }} </span>
            </label>
          </td>
        </tr>

        <tr>
          <td class="height-1"></td>
        </tr>

        <tr>
          <td style="text-align: center">
            <h4>BIÊN BẢN GIAO HÀNG</h4>
          </td>
        </tr>

        <tr>
          <td class="height-1"></td>
        </tr>
      </table>

      <table class="table-detail">
        <thead>
          <tr style="text-align: center">
            <th>
              <strong> STT </strong>
            </th>
            <th>
              <strong> Mã hàng </strong>
            </th>
            <th>
              <strong> Tên hàng </strong>
            </th>
            <th>
              <strong> ĐVT </strong>
            </th>
            <th>
              <strong>SL</strong>
            </th>
            <th>
              <strong> Ghi chú </strong>
            </th>
          </tr>
        </thead>
        <tbody *ngFor="let item of receiptDetails; let i = index">
          <tr *ngIf="item.receipt">
            <td colspan="3">
              <b>KH: </b> {{ item.receipt.customerName }}
              <span *ngIf="item.receipt.customerMobile"
                >- {{ item.receipt.customerMobile }}</span
              >
              <span *ngIf="item.receipt.customerAddress"
                >- {{ item.receipt.customerAddress }}</span
              >
            </td>
            <td colspan="2">* {{ item.receipt.deliveryNote }}</td>
            <td>Ngày HĐ: {{ item.receipt.issueDate | date: "dd/MM/yyyy" }}</td>
          </tr>
          <tr>
            <td>{{ i + 1 }}</td>
            <td>{{ item.productCode }}</td>
            <td>{{ item.productName }}</td>
            <td>
              {{ item.productUnitName }}
            </td>
            <td style="text-align: right">
              {{ item.quantity | number: 0 }}
            </td>
            <td>
              {{ item.comment }}
            </td>
          </tr>
        </tbody>

        <tfoot>
          <tr>
            <td colspan="4" style="text-align: right">
              <strong> TỔNG CỘNG: </strong>
            </td>
            <td style="text-align: right">
              <strong> {{ totalQuantity | number: 0 }} </strong>
            </td>
            <td></td>
          </tr>
        </tfoot>
      </table>

      <table width="100%" cellpadding="0" cellspacing="0" class="table-header">
        <tr>
          <td colspan="3" class="height-1"></td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td style="text-align: center">
            <span>
              Ngày {{ currentDate | date: "dd " }} tháng
              {{ currentDate | date: "MM " }} năm
              {{ currentDate | date: "yyyy " }}</span
            >
          </td>
        </tr>

        <tr>
          <td style="text-align: center">
            <strong>Bộ phận sản xuất </strong> <br />
            <span> (Ký, họ tên) </span>
          </td>

          <td style="text-align: center">
            <strong>Người đi giao </strong> <br />
            <span> (Ký, họ tên) </span>
          </td>

          <td style="text-align: center">
            <strong>Kế toán kho </strong> <br />
            <span> (Ký, họ tên) </span>
          </td>
        </tr>
      </table>
    </div>
  </nb-card-body>

  <nb-card-footer>
    <!--- This is hidden using CSS ----->
    <button
      type="button"
      class="btn btn-sm d-none"
      ngxPrint
      printSectionId="print-section"
      styleSheetFile="assets/css/layout-print.css"
      #printBtn
      ngxPrint
    >
      Auto Print
    </button>

    <button
      *ngIf="!printing"
      nbButton
      hero
      shape="semi-round"
      status="info"
      size="medium"
      (click)="print()"
      [disabled]="loading"
      [class.btn-pulse]="loading"
      id="btnPrint"
    >
      <nb-icon icon="printer-outline"></nb-icon>
      {{ "buttons.print" | translate }}
    </button>
  </nb-card-footer>
</nb-card>
